<template>
  <div class="RoleList">
    <XTable
        :api="getRoleList"
        :state="roleList"
        :columns="columns"
        :loading="isBack"
        :tableSize="tableSize"
        :layout="layout"
        :maxHeight="maxHeight"
        :firstColumn="firstColumn"
    ></XTable>
  </div>
</template>

<script>
import XTable from "@/components/XTable/index.vue";
import {mapActions, mapState} from "vuex";
import DateUtil from "@/utils/formatDate";

export default {
  name: "RoleList",
  components: {XTable},
  props: {
    maxHeight: {
      type: Number,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      firstColumn: true,
      tableSize: "small",
      layout: "sizes, prev, pager, next",
      previewList: [],
    };
  },
  computed: {
    ...mapState("fuzhu", ["roleList"]),
    ...mapState("teachingCenter", ["isBack"]),
    ...mapState("user", ["permissionCode"]),
    columns: function () {
      const self = this;
      const columns = [
        {
          prop: "name",
          label: "角色",
        },
        {
          label: "部门",
          render(h, scope) {
            return (
                <div>{(scope.row && scope.row.assistDepartName) || "其他"}</div>
            );
          },
        },
        // {
        //   prop: "name",
        //   label: "岗位职责",
        // },
        {
          label: "任务清单",
          render(h, scope) {
            return (
                <div class="box">
                  {scope.row &&
                      scope.row.assistRoleMaterial &&
                      scope.row.assistRoleMaterial.taskImage.materialUrl && (
                          <el-image
                              class="setPic"
                              src={scope.row.assistRoleMaterial.taskImage.materialUrl}
                              alt=""
                              preview-src-list={[
                                scope.row.assistRoleMaterial.taskImage.materialUrl,
                              ]}
                          ></el-image>
                      )}
                  {scope.row &&
                      !scope.row.assistRoleMaterial.taskImage.materialUrl && (
                          <span>-</span>
                      )}
                </div>
            );
          },
        },
        {
          label: "编辑时间",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.updateTime)}</span>
                </div>
            );
          },
        },
      ];
      let roleManager = this.permissionCode.has('assist:role:manager');
      let taskManager = this.permissionCode.has('assist:task:list');
      if (roleManager) {
        columns.push({
          label: "调整顺序",
          width: 150,
          render(h, scope) {
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleUp(scope);
                      }}
                      disabled={self.isUp() && scope.$index === 0}
                      size="mini"
                      type="primary"
                      plain
                  >
                    上移
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleDown(scope);
                      }}
                      disabled={self.isDown() === scope.$index}
                      size="mini"
                      type="primary"
                      plain
                  >
                    下移
                  </el-button>
                </div>
            );
          }
        });

      }
      if (roleManager || taskManager) {
        columns.push({
          label: "操作",
          fixed: "right",
          width: 300,
          render(h, scope) {
            return (
                <div>
                  {roleManager && !scope.row.noEdit &&
                      <el-button
                          onClick={() => {
                            self.handleEdit(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        编辑
                      </el-button>
                  }
                  {roleManager && !scope.row.noEdit &&
                      <el-button
                          onClick={() => {
                            self.handleDelete(scope.row);
                          }}
                          size="mini"
                          type="danger"
                          plain
                      >
                        删除
                      </el-button>
                  }
                  {taskManager &&
                      <el-button
                          onClick={() => {
                            self.handleToTask(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        任务
                      </el-button>}
                  {taskManager && !scope.row.noEdit &&
                      <el-button
                          onClick={() => {
                            self.deployRole(scope.row);
                          }}
                          size="mini"
                          type="primary"
                          plain
                      >
                        {scope.row.deployed ? "下架" : "上架"}
                      </el-button>}
                </div>
            );
          },
        })
      }
      return columns;
    }
  },
  methods: {
    ...mapActions("fuzhu", ["getRoleList", "deleteRole", "moveAssistRole", "deployAssistRole"]),
    isUp() {
      return this.roleList.page === 1;
    },
    isDown() {
      return this.roleList.total - (this.roleList.page - 1) * this.roleList.size - 1;
    },
    // 上移
    async handleUp(scope) {
      await this.moveFun(true, scope);
    },
    // 下移
    async handleDown(scope) {
      await this.moveFun(false, scope);
    },
    // 移动方法
    async moveFun(previewDirect, scope) {
      const offset = (this.roleList.page - 1) * this.roleList.size + scope.$index + 1;
      await this.moveAssistRole({
        previewDirect: previewDirect,
        offset: offset,
        step: 1,
      });
      await this.getRoleList({})
    },
    handleEdit(row) {
      localStorage.setItem("roleDetail", JSON.stringify(row));
      this.$router.push(
          {
            name: "AddRole",
            params: {
              type: "edit",
              assistDepartId: 0,
            },
          },
          () => {
          }
      );
    },
    handleDelete(row) {
      this.$confirm(
          "删除角色后，该角色下所有任务也将删除，请确认是否继续删除!",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
            closeOnClickModal: false,
          }
      )
          .then(async () => {
            await this.deleteRole({
              id: row.id,
            });
            this.$message.success("删除成功");
            await this.getRoleList({});
          })
          .catch(() => {
          });
    },
    handleToTask(row) {
      this.$router.push(
          {
            name: "TaskManagement",
            params: {
              assistRoleId: this.$Base64.encode(row.id),
            },
          },
          () => {
          }
      );
    },
    async deployRole(row) {
      await this.deployAssistRole({
        id: row.id,
        enable: !row.deployed
      });
      await this.getRoleList({});
    },
    // 根据时间戳计算编辑日期
    formatDate(timestamp) {
      return DateUtil.formatDateFromTimestamp(timestamp);
    },
  },
};
</script>

<style lang="scss" scoped>
.RoleList {
  ::v-deep .box {
    line-height: 28px;
    height: 28px;
    cursor: pointer;
  }

  ::v-deep img {
    width: 40px !important;
    height: 28px !important;
    line-height: 28px !important;
  }
}
</style>
